import { ForkCommandContext } from '#pplx/frontend/apps/ask/providers/BranchModeProviderShared.js';
import { ASK_INPUT_MENU } from '#pplx/frontend/apps/ask/types/askInputMenu.js';
import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { useCallback, useContext } from 'react';
/** Routes the command menu's Search, Model, side-chat, and fork actions through the owning input. */
export function useComputerCommandMenuUiActionSelect({ computerCommandMenuSearchQuery, isFollowUp, onActiveMenuChange, onSideChatCommandSelect, searchModeControllerProps, }) {
    const startFork = useContext(ForkCommandContext);
    return useCallback((actionId, closeMenu) => {
        if (actionId === 'fork_session') {
            closeMenu();
            startFork?.();
            return;
        }
        if (actionId === 'open_side_chat') {
            closeMenu();
            onSideChatCommandSelect?.(computerCommandMenuSearchQuery);
            return;
        }
        if (actionId === 'switch_to_search_mode') {
            if (!searchModeControllerProps.showSearchMode || isFollowUp)
                return;
            searchModeControllerProps.onSearchModeSelect(SearchMode.SEARCH);
            return;
        }
        if (actionId !== 'open_model_selector')
            return;
        onActiveMenuChange(ASK_INPUT_MENU.SEARCH_MODEL_MENU);
    }, [
        computerCommandMenuSearchQuery,
        isFollowUp,
        onActiveMenuChange,
        onSideChatCommandSelect,
        searchModeControllerProps,
        startFork,
    ]);
}
//# sourceMappingURL=useComputerCommandMenuUiActionSelect.js.map